"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONFIG = exports.URL = exports.ADRUM_CONFIG = exports.ADRUM_START_TIME = exports.LOAD_CONFIG = void 0;
const constants_1 = require("../../../core/script/constants");
exports.LOAD_CONFIG = { order: constants_1.OrderConfig.BOTTOM, sync: constants_1.SyncConfig.DEFER };
exports.ADRUM_START_TIME = 'adrudm-start-time';
exports.ADRUM_CONFIG = 'adrum-config';
exports.URL = 'https://cdn.appdynamics.com/adrum/adrum-latest.js';
exports.CONFIG = {
    adrumExtUrlHttp: 'http://cdn.appdynamics.com',
    adrumExtUrlHttps: 'https://cdn.appdynamics.com',
    beaconUrlHttp: 'http://fra-col.eum-appdynamics.com',
    beaconUrlHttps: 'https://fra-col.eum-appdynamics.com',
    maxUrlLength: 512,
    resTiming: { bufSize: 200, clearResTimingOnBeaconSend: true },
    spa: { spa2: true },
    xd: { enable: true },
};
//# sourceMappingURL=constants.js.map